import React from "react";

export function PaydayEnvBadge({ config, testId = "payday-env-badge" }) {
  if (!config) return null;

  const envLabel = String(config.env || "sandbox").toUpperCase();
  const mocked = !!config.mocked;
  const enabled = !!config.enabled;
  const productionTestMode = !!config.production_test_mode_active;

  return (
    <div className="mt-3 flex flex-wrap items-center gap-2" data-testid={testId}>
      <span className="inline-flex items-center rounded-full bg-sky-100 px-2.5 py-1 text-xs font-semibold text-sky-900 ring-1 ring-inset ring-sky-200">
        Payday {envLabel}
      </span>
      {productionTestMode && (
        <span className="inline-flex items-center rounded-full bg-red-100 px-2.5 py-1 text-xs font-semibold text-red-900 ring-1 ring-inset ring-red-200">
          ⚠️ PAYDAY LIVE – TEST MODE ACTIVE (ALL INVOICES GO TO TEST IDENTITY)
        </span>
      )}
      {mocked && (
        <span className="inline-flex items-center rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-900 ring-1 ring-inset ring-amber-200">
          MOCKED sandbox fallback
        </span>
      )}
      {!enabled && (
        <span className="inline-flex items-center rounded-full bg-slate-200 px-2.5 py-1 text-xs font-semibold text-slate-700 ring-1 ring-inset ring-slate-300">
          Payday disabled
        </span>
      )}
    </div>
  );
}